(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.EVO4Campaign2024_AVR_1800x800px_BG = function() {
	this.initialize(img.EVO4Campaign2024_AVR_1800x800px_BG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1427,951);


(lib.EVO4Campaign2024_Speakers = function() {
	this.initialize(img.EVO4Campaign2024_Speakers);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,322);


(lib.WhiteBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EiTaBypMAqKkM5MD8rAnoMgqKEM4g");
	this.shape.setTransform(943.525,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(164).to({_off:true},1).wait(135));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-987.2,1887.1,1974.5);


(lib.WharfedaleLogo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#232020").s().p("AhKBxIAAjhICTAAIAAAUIh+AAIAABRIBuAAIAAASIhuAAIAABWICBAAIAAAUg");
	this.shape.setTransform(357.45,0.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#232020").s().p("AhLBxIAAjhIAWAAIAADNICBAAIAAAUg");
	this.shape_1.setTransform(327.9,0.025);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#232020").s().p("ABQBxIgdhHIhlAAIgdBHIgXAAIBejhIASAAIBdDhgAgtAZIBaAAIgthvg");
	this.shape_2.setTransform(295.625,0.025);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#232020").s().p("AhbBxIAAjhIBNAAQAZAAAVAJQATAJAOAPQAOAQAHAUQAGAUAAAXQAAAZgHAVQgIAUgOAQQgNAOgVAJQgWAIgVAAgAhFBdIA3AAQAUAAAQgHQAOgHAMgNQAKgLAHgSQAFgSAAgTQAAgTgFgSQgHgRgKgMQgLgMgQgHQgQgHgTAAIg3AAg");
	this.shape_3.setTransform(263.95,0.025);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#232020").s().p("AhKBxIAAjhICTAAIAAAUIh+AAIAABRIBuAAIAAASIhuAAIAABWICBAAIAAAUg");
	this.shape_4.setTransform(231.9,0.025);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#232020").s().p("AhJBxIAAjhICTAAIAAAUIh9AAIAABTIBpAAIAAARIhpAAIAABpg");
	this.shape_5.setTransform(201.95,0.025);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#232020").s().p("AA6BxIg1hTIhBAAIAABTIgXAAIAAjhIBfAAQAPAAALAHQAMAGAJAKQAJAJAGANQAEAOAAAMQAAAMgDAMQgFANgFAGQgIAKgIAFQgLAHgKACIA3BXgAg8AKIBIAAQAKAAAIgEQAIgEAGgHQAGgHADgKQADgJAAgKQAAgLgDgIQgEgJgHgIQgGgHgIgEQgHgEgKAAIhHAAg");
	this.shape_6.setTransform(171.1,0.025);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#232020").s().p("ABQBxIgdhHIhlAAIgcBHIgYAAIBejhIASAAIBdDhgAgtAZIBbAAIguhvg");
	this.shape_7.setTransform(138.075,0.025);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#232020").s().p("ABDBxIAAhqIiEAAIAABqIgXAAIAAjhIAXAAIAABlICEAAIAAhlIAWAAIAADhg");
	this.shape_8.setTransform(104.55,0.025);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#232020").s().p("AAvBxIgvhwIgvBwIgTAAIhfjhIAXAAIBSDHIArhlIgnhgIAVAAIAfBQIAfhQIAWAAIgoBgIAsBlIBRjHIAYAAIhfDhg");
	this.shape_9.setTransform(65.175,0.025);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#232020").s().p("AiKC6QgTAAgOgNQgOgOAAgUIAAkVQAAgUAOgNQAOgOATAAIEVAAQAUAAAOAOQANANAAAUIAAEVQAAAUgNAOQgOANgUAAgAieieQgIAIAAAMIAAEVQAAAMAIAIQAIAIAMAAIEVAAQAMAAAJgIQAIgIAAgMIAAkVQAAgMgIgIQgJgIgMAAIkVAAQgMAAgIAIg");
	this.shape_10.setTransform(18.625,0.025);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#232020").s().p("AgZgdIAzAAIgbA7g");
	this.shape_11.setTransform(29.225,-6.675);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#232020").s().p("AgzhgIA0AAIAyCCIgYA/g");
	this.shape_12.setTransform(21.25,0.025);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#232020").s().p("AgyhgIAzAAIAyCCIgZA/g");
	this.shape_13.setTransform(10.6,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},151).to({state:[]},1).wait(148));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-18.6,365,37.3);


(lib.ThirtyOff = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("Ak7FpQh0iPAAjXIAAgDQAAjWB1iQQB6iYDBAAQDCAAB5CWQB0CPAADXIAAACQAADXh0CRQh6CXjCAAQjCAAh5iWgAh8jDQgvBLAAB2IAAACQAAB3AwBKQAwBNBMAAQBOAAAvhMQAuhJAAh2IAAgDQAAh2gvhMQgxhMhMAAQhNAAgvBLg");
	this.shape.setTransform(125.825,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("Al6FHICkirQA0A4A0AbQA4AdA+AAQA2AAAhgbQAfgbAAguIAAgCQABgwgngbQgogahJAAIhtAAIgkiNIDVjMIlkAAIAAjcIKhAAIAADBIjfDLQDyA4AADbIAAADQAACUhmBaQhkBZifAAQj0AAiYiug");
	this.shape_1.setTransform(37.9,0.975);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("ABRD+QgngtABhBIAAgCQgBhCAngsQApgtBAAAQA/AAAoAtQAnAsAABCIAAABQAABCgoAsQgoAvg/AAQg/AAgpgugACYBfQgNASAAAdIAAABQAAAcAOASQANATAUAAQATAAANgSQANgSABgcIAAgCQgBgcgNgTQgNgSgUAAQgVAAgMASgAkKEjIDpk5IDCkNIBqAAImrJGgAkggfQgngtAAhBIAAgBQAAhCAngtQApguA/AAQBAAAAoAuQAmAsAABCIAAABQAABBgnAtQgpAtg/AAQg+AAgpgsgAjai+QgNASAAAdIAAABQAAAcAOATQAOASATAAQAUAAANgSQANgSAAgcIAAgBQAAgcgOgTQgMgTgVAAQgUAAgNASg");
	this.shape_2.setTransform(212.85,-20.525);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AjZEeIAAo7IGzAAIAACLIkcAAIAABhIEBAAIAACDIkBAAIAADMg");
	this.shape_3.setTransform(395.275,-19.575);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AjZEeIAAo7IGzAAIAACLIkcAAIAABhIEBAAIAACDIkBAAIAADMg");
	this.shape_4.setTransform(344.825,-19.575);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AjRDTQhThVAAh8IAAgCQAAh7BUhWQBVhYB8AAQB9AABUBXQBTBVAAB8IAAABQAAB9hUBWQhVBXh8AAQh9AAhUhXgAhkhsQgmAsAAA/IAAABQAABAAmAsQApAvA8AAQA8AAAnguQAmgsAAg/IAAgCQAAg/gmgtQgogug8AAQg9AAgnAug");
	this.shape_5.setTransform(285.975,-19.575);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("AAUB5IAAg0IhuAAIgIgmIB8iXIAqAAIAACSIAfAAIAAArIgfAAIAAA0gAgnAaIA7AAIAAhKg");
	this.shape_6.setTransform(274.825,37.25);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("AhWBYQgigkAAgzIAAgBQAAgzAigkQAjgkAzAAQA1AAAiAkQAiAjAAA0IAAAAQAAA0giAkQgjAkg0AAQgzAAgjgkgAgxg1QgTAWAAAfIAAAAQAAAfAUAWQATAWAdAAQAeAAAUgWQATgVAAgfIAAgBQAAgfgUgVQgTgXgeAAQgdAAgUAWg");
	this.shape_7.setTransform(238.925,37.325);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("AgVB5IhdjxIA4AAIA7CoIA8ioIA2AAIhdDxg");
	this.shape_8.setTransform(213.65,37.4);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("AhWB4IAAjvICrAAIAAAvIh5AAIAAAxIBrAAIAAAuIhrAAIAAAyIB7AAIAAAvg");
	this.shape_9.setTransform(190.35,37.325);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("AhVBWIAQgUQASARASAIQATAJAWAAQAYAAANgMQAOgLABgSIAAgBQAAgSgMgJQgNgLgjgIQgngJgSgOQgTgRAAgdIAAAAQAAgdAVgSQAWgTAgAAQAtAAAjAeIgPAVQgfgbgiAAQgWAAgNAMQgOALAAAQIAAABQAAASANAKQANALAjAIQAnAJASAPQASAQAAAbIAAABQAAAfgWATQgWASgiAAQg0AAgpgmg");
	this.shape_10.setTransform(408.7,37.125);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("AhTB5IAAjxIClAAIAAAZIiLAAIAABTIB8AAIAAAXIh8AAIAABVICNAAIAAAZg");
	this.shape_11.setTransform(387.375,37.125);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("AgMB5IAAjxIAZAAIAADxg");
	this.shape_12.setTransform(370.3,37.125);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("AA/B5IhBheIhCAAIAABeIgaAAIAAjxIBiAAQAqAAAXAYQASATAAAdIAAABQAAAdgSASQgQARgdAFIBHBjgAhEACIBFAAQAbAAAQgMQAQgNAAgXIAAgBQAAgWgPgNQgQgNgbAAIhGAAg");
	this.shape_13.setTransform(353.925,37.125);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("AhTB5IAAjxIClAAIAAAZIiLAAIAABTIB9AAIAAAXIh9AAIAABVICNAAIAAAZg");
	this.shape_14.setTransform(330.175,37.125);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("AhVBWIAQgUQASARATAIQATAJAVAAQAYAAAOgMQAOgLgBgSIAAgBQAAgSgLgJQgNgLgjgIQgogJgRgOQgTgQAAgeIAAAAQAAgdAVgSQAWgTAgAAQAtAAAjAeIgPAVQgfgbgjAAQgVAAgOAMQgNALAAAQIAAABQAAASAMAKQAOALAjAIQAnAJARAPQATAQAAAbIAAABQAAAfgWATQgWASgjAAQgyAAgqgmg");
	this.shape_15.setTransform(307.3,37.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},127).to({state:[]},1).wait(172));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-51.1,417.3,102.2);


(lib.ShopNow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AApBQIgph/IgoB/IgOAAIg2ieIASAAIArCCIAqiDIANAAIApCDIAriCIARAAIg1Ceg");
	this.shape.setTransform(134.325,0.15);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("Ag3A5QgUgXgBgiIAAAAQABghAUgXQAXgZAgAAQAiAAAWAYQAUAYAAAhIAAAAQAAAhgUAYQgWAZgiAAQggAAgXgZgAgpgtQgRASAAAbIAAAAQAAAbARATQARATAYAAQAaAAAQgTQARgSAAgcIAAAAQAAgagRgTQgQgTgaAAQgZAAgQATg");
	this.shape_1.setTransform(114.1,0.125);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("AAyBPIhgiBIAACBIgRAAIAAidIAQAAIBeB+IAAh+IAQAAIAACdg");
	this.shape_2.setTransform(96.5,0.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("Ag3BPIAAidIA3AAQAZAAAQAOQAPANAAAXIAAABQAAAYgRANQgQANgZAAIgkAAIAAA4gAgmAHIAlAAQARAAAMgIQALgKAAgPIAAgBQAAgQgLgJQgLgKgRABIgmAAg");
	this.shape_3.setTransform(74.975,0.1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("Ag3A5QgUgXAAgiIAAAAQAAghAUgXQAWgZAhAAQAhAAAXAYQAUAYABAhIAAAAQgBAhgUAYQgXAZghAAQghAAgWgZgAgpgtQgRASAAAbIAAAAQAAAbARATQARATAYAAQAaAAAQgTQARgSAAgcIAAAAQAAgbgRgSQgRgTgZAAQgZAAgQATg");
	this.shape_4.setTransform(58.1,0.125);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AArBPIAAhHIhWAAIAABHIgRAAIAAidIARAAIAABHIBWAAIAAhHIASAAIAACdg");
	this.shape_5.setTransform(40.8,0.1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("Ag3A4IAKgNQAYAWAbAAQAPAAAJgHQAJgIAAgMIAAAAQAAgMgHgGQgJgHgXgFQgZgGgMgJQgMgLAAgTIAAAAQAAgTAOgMQAOgMAVAAQAdAAAXATIgKAOQgTgRgXAAQgPAAgJAHQgIAHAAALIAAABQAAALAIAHQAJAHAWAFQAaAGALAJQAMALAAASQAAAVgOAMQgOAMgXAAQghAAgbgZg");
	this.shape_6.setTransform(25.675,0.125);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f().s("#000000").ss(1.5,0,0,60).p("AsujGIAAGNIZcAAIAAmNg");
	this.shape_7.setTransform(82.45,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},101).to({state:[]},1).wait(198));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-20.9,164.9,41.8);


(lib.OfferValidUntil = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgLANIAAgZIAXAAIAAAZg");
	this.shape.setTransform(483.1,4.3);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgRAjIAAg0IgMAAIAAgTIAMAAIAAgcIAVAAIAAAcIAaAAIAAATIgaAAIAAAxQAAAMAMAAQAGAAAIgDIAAASQgJAGgLAAQgbAAAAgeg");
	this.shape_1.setTransform(476.825,-0.675);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AglAlIAKgPQAQAMAOAAQAPAAAAgLIAAgBQAAgEgHgEIgOgGQgNgDgHgFQgJgHAAgNIAAgBQAAgNAKgJQAJgIAOAAQATAAAQAMIgJAQQgOgJgMAAQgNgBAAALQAAAEAGAEIAPAGQANAEAHAFQAJAHAAAMIAAABQAAAOgKAJQgKAIgQAAQgVAAgSgPg");
	this.shape_2.setTransform(468.75,0.6);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AggAsQgKgIAAgPIAAAAQAAgQALgIQAKgIASAAQAMAAANAFIAAgDQAAgWgXAAQgMAAgPAGIgGgSQATgIAQAAQAWAAAKALQAKAMAAATIAAA7IgVAAIAAgNQgLAPgTAAQgPAAgJgIgAgVAUIAAAAQAAAHAGAEQAFAEAIAAQAKAAAHgGQAHgGAAgJIAAgHQgLgEgKAAQgWAAAAARg");
	this.shape_3.setTransform(458.825,0.625);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgKBFIAAiJIAVAAIAACJg");
	this.shape_4.setTransform(451.2,-1.325);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AglAlIAJgPQARAMAOAAQAPAAAAgLIAAgBQAAgEgGgEIgOgGQgOgDgGgFQgKgHAAgNIAAgBQAAgNAKgJQAJgIANAAQATAAAQAMIgIAQQgOgJgNAAQgMgBAAALQgBAEAHAEIAOAGQAOAEAGAFQAKAHAAAMIAAABQAAAOgKAJQgKAIgQAAQgVAAgSgPg");
	this.shape_5.setTransform(438.55,0.6);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AATBFIgbgrIgOAPIAAAcIgWAAIAAiJIAWAAIAABSIAngsIAaAAIgmAoIAoA7g");
	this.shape_6.setTransform(429.475,-1.325);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AgdAlQgOgPAAgWIAAAAQAAgVAOgPQAPgPATAAQAXAAAPARIgNAPQgLgMgOAAQgLAAgIAJQgIAKAAAMQAAANAIAKQAJAJALAAQAOAAALgMIANANQgRATgWAAQgUAAgOgPg");
	this.shape_7.setTransform(418.6,0.625);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgkAlQgOgPAAgWIAAAAQAAgVAOgPQAPgPAVAAQAWAAAOAPQAPAPAAAVQAAAVgPAQQgOAPgWAAQgVAAgPgPgAgUgWQgIAJAAANQAAANAIAKQAJAJALAAQANAAAIgJQAIgJAAgOIAAAAQAAgNgIgJQgJgJgMAAQgNAAgHAJg");
	this.shape_8.setTransform(407.4,0.625);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgRAjIAAg0IgMAAIAAgTIAMAAIAAgcIAVAAIAAAcIAaAAIAAATIgaAAIAAAxQAAAMAMAAQAFAAAIgDIAAASQgIAGgLAAQgbAAAAgeg");
	this.shape_9.setTransform(397.925,-0.675);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AglAlIAKgPQAQAMAOAAQAPAAAAgLIAAgBQAAgEgHgEIgNgGQgOgDgGgFQgLgHAAgNIAAgBQAAgNALgJQAJgIANAAQATAAAQAMIgIAQQgOgJgNAAQgMgBAAALQgBAEAHAEIAOAGQAOAEAGAFQAKAHAAAMIAAABQAAAOgKAJQgKAIgQAAQgVAAgSgPg");
	this.shape_10.setTransform(389.85,0.6);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgfAmQgOgPAAgXIAAAAQAAgVANgPQANgPAUAAQAVAAAMAQQAMAPAAAVIAAAHIhGAAQACAMAIAHQAIAGAJAAQAPAAALgMIAMAMQgOATgYAAQgVAAgNgOgAgPgZQgHAHgCAMIAwAAQAAgMgHgHQgGgIgLAAQgIAAgHAIg");
	this.shape_11.setTransform(374.6,0.625);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgKBFIAAiJIAVAAIAACJg");
	this.shape_12.setTransform(366.55,-1.325);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AgKBFIAAhjIAVAAIAABjgAgLguIAAgWIAXAAIAAAWg");
	this.shape_13.setTransform(361.375,-1.275);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AAVBFIAAg5QAAgXgVAAQgIAAgGAGQgGAGAAAMIAAA4IgWAAIAAiJIAWAAIAAA1QAMgRARAAQAQAAAJALQAJAKAAAQIAABAg");
	this.shape_14.setTransform(353.275,-1.325);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AAVAzIgVhEIgVBEIgTAAIgfhkIAWAAIATBDIAVhEIATAAIAUBEIAUhDIAWAAIggBkg");
	this.shape_15.setTransform(339.85,0.625);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AgbAzIAAhjIAWAAIAAAXQAKgaAXABIAAAZIgBAAQgPAAgJAKQgIAKAAASIAAAmg");
	this.shape_16.setTransform(323.325,0.4959);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFFF").s().p("AgkAlQgOgPAAgWIAAAAQAAgVAPgPQAOgPAVAAQAWAAAOAPQAPAPAAAVQAAAVgPAQQgPAPgVAAQgVAAgPgPgAgUgWQgIAJAAANQAAANAIAKQAIAJAMAAQANAAAIgJQAIgJAAgOIAAAAQAAgNgIgJQgJgJgMAAQgMAAgIAJg");
	this.shape_17.setTransform(313.275,0.625);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#FFFFFF").s().p("AAOBDIAAgdIg/AAIgEgRIBGhXIATAAIAABUIASAAIAAAUIgSAAIAAAdgAgaASIAoAAIAAgzg");
	this.shape_18.setTransform(295.6,-1.1);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#FFFFFF").s().p("AgtBDIAAgSIAsgnQANgLAEgHQAGgIAAgJQAAgJgGgGQgGgGgJAAQgNAAgPAUIgQgNQAKgOAKgGQALgHAPAAQATAAALALQAMAKAAASIAAABQAAAOgIAMQgHAIgSAQIgZAXIA7AAIAAAUg");
	this.shape_19.setTransform(284.325,-1.125);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#FFFFFF").s().p("AgnAxQgPgUAAgdIAAAAQAAgcAPgUQAQgUAXAAQAZAAAPAUQAPAUAAAcQAAAdgPAUQgQAUgYAAQgYAAgPgUgAgXghQgIANAAAUQAAAUAJAOQAJAOANAAQAPAAAJgOQAIgOAAgUIAAAAQAAgTgJgOQgJgOgOAAQgOAAgJAOg");
	this.shape_20.setTransform(272.525,-1.025);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#FFFFFF").s().p("AgtBDIAAgSIAsgnQANgLAEgHQAGgIAAgJQAAgJgGgGQgGgGgJAAQgNAAgPAUIgQgNQAKgOAKgGQALgHAPAAQASAAAMALQALAKAAASIAAABQAAAOgIAMQgGAIgSAQIgZAXIA7AAIAAAUg");
	this.shape_21.setTransform(260.375,-1.125);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("AgOARQAQgEgCgNIgIAAIAAgaIAXAAIAAAWQAAAPgHAHQgGAIgOABg");
	this.shape_22.setTransform(246.775,5.7);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFFF").s().p("AADBDIAAhtIgWAHIgFgUIAigLIAPAAIAACFg");
	this.shape_23.setTransform(240.425,-1.1);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AguAsIAQgPQAPASASAAQAJAAAGgGQAGgGAAgJQABgUgdAAIgKAAIgEgOIAhgmIg2AAIAAgVIBTAAIAAASIgjAmQAmAFAAAfIAAABQAAASgNAMQgMAMgUAAQgcAAgUgYg");
	this.shape_24.setTransform(231.75,-0.925);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFFF").s().p("AgbAzIAAhjIAWAAIAAAXQAJgaAYABIAAAZIgBAAQgPAAgJAKQgIAKAAASIAAAmg");
	this.shape_25.setTransform(217.625,0.4959);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("AgfAmQgOgPAAgXIAAAAQAAgVANgPQANgPATAAQAWAAANAQQALAPAAAVIAAAHIhFAAQACAMAHAHQAIAGAJAAQAPAAALgMIANAMQgPATgYAAQgUAAgOgOgAgPgZQgHAHgBAMIAvAAQgBgMgGgHQgGgIgLAAQgJAAgGAIg");
	this.shape_26.setTransform(208.025,0.625);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#FFFFFF").s().p("AgaA1IAAAPIgXAAIAAiJIAXAAIAAA3QAMgTATAAQASAAAMAOQAPAOgBAXQABAYgPAPQgMANgSAAQgUAAgLgRgAgTgEQgIAIAAAOQAAAPAIAJQAIAJALAAQAMAAAHgJQAIgJAAgPQAAgOgIgIQgIgJgLAAQgLAAgIAJg");
	this.shape_27.setTransform(196.75,-1.225);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#FFFFFF").s().p("AgjAlQgPgPAAgWIAAAAQAAgVAPgPQAOgPAVAAQAWAAAOAPQAPAPAAAVQAAAVgPAQQgOAPgWAAQgVAAgOgPgAgUgWQgIAJAAANQAAANAIAKQAJAJALAAQANAAAIgJQAIgJAAgOIAAAAQAAgNgIgJQgJgJgMAAQgMAAgIAJg");
	this.shape_28.setTransform(184.525,0.625);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#FFFFFF").s().p("AgRAjIAAg0IgMAAIAAgTIAMAAIAAgcIAVAAIAAAcIAaAAIAAATIgaAAIAAAxQAAAMAMAAQAGAAAHgDIAAASQgIAGgLAAQgbAAAAgeg");
	this.shape_29.setTransform(175.025,-0.675);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#FFFFFF").s().p("AgdAlQgOgPAAgWIAAAAQAAgVAOgPQAOgPAVAAQAWAAAQARIgOAPQgLgMgOAAQgKAAgIAJQgIAKAAAMQAAANAIAKQAIAJALAAQAOAAALgMIANANQgQATgXAAQgUAAgOgPg");
	this.shape_30.setTransform(166.375,0.625);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#FFFFFF").s().p("AgvAxQgSgUAAgdIAAAAQAAgcASgUQAUgUAbAAQAdAAATAUQASAUAAAcQAAAcgSAUQgUAVgcAAQgbAAgUgUgAgeggQgMANAAATQAAAUAMANQANAOARAAQATAAAMgNQAMgOAAgUIAAAAQAAgTgMgNQgNgOgSAAQgSAAgMAOg");
	this.shape_31.setTransform(153.45,-1.025);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#FFFFFF").s().p("AgKBFIAAiJIAVAAIAACJg");
	this.shape_32.setTransform(137.8,-1.325);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#FFFFFF").s().p("AgKBFIAAhjIAVAAIAABjgAgLguIAAgWIAXAAIAAAWg");
	this.shape_33.setTransform(132.625,-1.275);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#FFFFFF").s().p("AgQAjIAAg0IgNAAIAAgTIANAAIAAgcIAUAAIAAAcIAaAAIAAATIgaAAIAAAxQAAAMAMAAQAFAAAIgDIAAASQgIAGgLAAQgbAAABgeg");
	this.shape_34.setTransform(126.2,-0.675);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#FFFFFF").s().p("AAVAzIAAg4QAAgZgVAAQgIABgGAGQgGAHAAAMIAAA3IgWAAIAAhjIAWAAIAAAPQAMgRARAAQAQAAAJALQAJAKAAARIAAA/g");
	this.shape_35.setTransform(117.075,0.5);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#FFFFFF").s().p("AghAoQgJgKAAgSIAAg+IAWAAIAAA4QAAAYAUAAQAJAAAGgHQAGgGAAgMIAAg3IAWAAIAABjIgWAAIAAgQQgLASgSAAQgQAAgJgLg");
	this.shape_36.setTransform(105.775,0.7);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#FFFFFF").s().p("AgiA5QgPgPAAgYQAAgXAOgOQAMgOATAAQASAAAOASIAAg2IAVAAIAACJIgVAAIAAgQQgNASgTAAQgSAAgMgNgAgSgEQgIAIAAAOQAAAPAIAJQAIAJAKAAQALAAAJgJQAIgJAAgPQAAgOgIgIQgJgJgLAAQgLAAgHAJg");
	this.shape_37.setTransform(88.5,-1.225);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#FFFFFF").s().p("AgKBFIAAhjIAVAAIAABjgAgLguIAAgWIAXAAIAAAWg");
	this.shape_38.setTransform(80.125,-1.275);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#FFFFFF").s().p("AgKBFIAAiJIAVAAIAACJg");
	this.shape_39.setTransform(74.95,-1.325);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#FFFFFF").s().p("AggAsQgKgIAAgPIAAAAQAAgQALgIQAKgIASAAQAMAAANAFIAAgDQAAgWgXAAQgLAAgQAGIgFgSQASgIARAAQAUAAALALQAKALAAAUIAAA7IgVAAIAAgNQgLAPgTAAQgOAAgKgIgAgVAUIAAAAQAAAHAGAEQAFAEAIAAQAKAAAHgGQAHgGAAgJIAAgHQgLgEgKAAQgWAAAAARg");
	this.shape_40.setTransform(66.8,0.625);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#FFFFFF").s().p("AgJAzIgnhlIAYAAIAYBJIAahJIAXAAIgnBlg");
	this.shape_41.setTransform(56.825,0.65);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#FFFFFF").s().p("AgbAzIAAhjIAWAAIAAAXQAJgaAYABIAAAZIgCAAQgPAAgIAKQgIAKAAASIAAAmg");
	this.shape_42.setTransform(42.75,0.4959);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#FFFFFF").s().p("AgfAmQgOgPAAgXIAAAAQAAgVANgPQANgPAUAAQAVAAANAQQALAPAAAVIAAAHIhGAAQACAMAIAHQAHAGAKAAQAPAAALgMIANAMQgPATgYAAQgUAAgOgOgAgQgZQgGAHgCAMIAxAAQgCgMgGgHQgGgIgKAAQgJAAgIAIg");
	this.shape_43.setTransform(33.15,0.625);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#FFFFFF").s().p("AARBGIAAhQIgMAAIAAgTIAMAAIAAgHQAAgRAHgIQAIgIANAAQAKAAAIADIAAATQgHgCgFAAQgNAAAAAPIAAAFIAZAAIAAATIgZAAIAABQgAgzBGIAAhQIgMAAIAAgTIAMAAIAAgHQABgRAHgIQAIgIAOAAQAJAAAJADIAAATQgIgCgGAAQgMAAAAAPIAAAFIAaAAIAAATIgZAAIAABQg");
	this.shape_44.setTransform(21.3,-1.375);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#FFFFFF").s().p("AguAxQgTgUAAgdIAAAAQAAgcATgUQASgUAdAAQAcAAASAUQATAUAAAcQAAAcgTAUQgTAVgcAAQgcAAgSgUgAgeggQgLANgBATQABAUALANQANAOASAAQASAAAMgNQAMgOAAgUIAAAAQAAgTgMgNQgMgOgTAAQgSAAgMAOg");
	this.shape_45.setTransform(6.6,-1.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},114).to({state:[]},1).wait(185));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-8.3,484.3,16.700000000000003);


(lib.Mission700Speakers = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.EVO4Campaign2024_Speakers();
	this.instance.setTransform(0,-161);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(114).to({_off:true},1).wait(185));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-161,553,322);


(lib.Cursor = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AggCQIgGgTQgRg9gmgsIgMgMQAAgBgBAAQAAgBAAAAQAAgBAAAAQAAgBAAgBIAFgJQACgFAFADIAMAIIAOAOQAHAIAIgDQAIgCAAgKIAAiHQAAgFADgGQADgDAEAAQAEAAADADQAEAHAAAJIAABUQAAAIAHAEQAFACAGgDQAFgEAAgGIAAgeQASgDACATIAAAbQAAAMAKAAQAKACADgJIABgGIAAgbQATgFABAWIAAAgQAAAJAJADQAFAAAEgCQAEgCABgEIABgkIAJAAQAGABACAFIADAKIgFBMQgDAagHAZIgLAlg");
	this.shape.setTransform(13.3107,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#373535").s().p("AgmCnIgHAAQgGgDgCgIQgPhEghgqQgIgJgRgRQgHgIADgHQAFgQADgFQAHgNALgDQALgDANAGIAMAIIAAhnQAAgMAEgKQAKgUAUAAQAUAAAKATQAEALAAALIAAAgIAOACQALACAIAIIAFADIARAAQAQACAJANQAAABABAAQAAABABAAQAAAAABAAQABAAAAAAIAUACQAVAFAFAXIACANQAAAagEAqQgEAmgSA6IgFANQgDAIgIAAgAhkgGIgFAJQAAABAAAAQAAABAAABQAAAAAAAAQABABAAAAIAMANQAmAsARA8IAGATIBxAAIALglQAHgYADgaIAFhMIgDgKQgCgFgGgBIgJAAIgBAkQgBADgEADQgEACgFgBQgJgCAAgJIAAggQgBgWgTAEIAAAcIgBAGQgDAJgKgCQgKgBAAgLIAAgcQgCgSgSADIAAAeQAAAGgFAEQgGADgFgDQgHgDAAgIIAAhUQAAgJgEgHQgDgEgEAAQgEAAgDAEQgDAGAAAFIAACHQAAAKgIACQgIADgHgIIgOgOIgMgIIgDgBQgCAAgCADg");
	this.shape_1.setTransform(13.2096,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_1},{t:this.shape}]},78).to({state:[]},1).wait(221));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-16.7,26.4,33.5);


(lib.BGImage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_19
	this.instance = new lib.EVO4Campaign2024_AVR_1800x800px_BG();
	this.instance.setTransform(0,-475.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(18).to({_off:true},1).wait(7).to({_off:false},0).wait(145).to({_off:true},1).wait(128));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-475.5,1427,951);


(lib.YourNext = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// EVO_4_Series
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("Ag/BOQgcgfAAgvIAAAAQAAgsAcgfQAegiArABQAXAAATAHQARAGAQAPIgQASQgagZgjAAQgfAAgXAaQgVAZAAAkIAAAAQAAAmAVAZQAWAZAkAAQAhAAAYgWIAAg0Ig9AAIAAgVIBUAAIAABUQgjAhgugBQgtAAgdgfg");
	this.shape.setTransform(249,13.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("ABDBqIiBitIAACtIgWAAIAAjTIAVAAIB+CpIAAipIAWAAIAADTg");
	this.shape_1.setTransform(220.8,13.075);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("AgKBqIAAjTIAVAAIAADTg");
	this.shape_2.setTransform(199.525,13.075);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("ABDBqIiBitIAACtIgWAAIAAjTIAVAAIB9CpIAAipIAXAAIAADTg");
	this.shape_3.setTransform(178.25,13.075);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AhJBqIAAjTICRAAIAAAWIh5AAIAABIIBsAAIAAAVIhsAAIAABKIB6AAIAAAWg");
	this.shape_4.setTransform(152.05,13.075);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AgLBqIAAi9IhDAAIAAgWICdAAIAAAWIhDAAIAAC9g");
	this.shape_5.setTransform(126.8,13.075);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("AhLBLIAPgSQAgAeAjAAQAVAAAMgKQAMgKAAgQIAAAAQAAgQgKgIQgMgKgdgGQgjgIgQgNQgQgOAAgZIAAgBQAAgZASgQQATgRAdAAQAnAAAeAaIgMATQgcgXgeAAQgTAAgMAKQgLAJAAAPIAAAAQAAAQALAJQAMAKAeAHQAiAHAPANQAQAOABAYIAAABQgBAbgSARQgUAQgeAAQgtAAglgig");
	this.shape_6.setTransform(102.85,13.075);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("AgKBqIAAjTIAVAAIAADTg");
	this.shape_7.setTransform(83.875,13.075);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("AhDBqIAAjTIAXAAIAAC9IBwAAIAAAWg");
	this.shape_8.setTransform(65.8,13.075);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("ABDBqIiBitIAACtIgWAAIAAjTIAVAAIB+CpIAAipIAWAAIAADTg");
	this.shape_9.setTransform(24.675,13.075);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("AgLBqIAAjTIAXAAIAADTg");
	this.shape_10.setTransform(3.4,13.075);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("ABDBqIiBitIAACtIgWAAIAAjTIAVAAIB+CpIAAipIAWAAIAADTg");
	this.shape_11.setTransform(470.55,-32.325);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("AhKBNQgcgfAAgtIAAgBQAAgsAdgfQAegiArABQAtAAAdAgQAdAgAAAsIAAAAQAAAtgdAgQgeAggsAAQgsABgeghgAg4g9QgWAZAAAkIAAAAQAAAlAWAZQAXAZAhABQAiAAAXgaQAWgZAAgkIAAgBQAAgjgWgaQgXgZgiAAQghAAgXAZg");
	this.shape_12.setTransform(441.225,-32.35);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("AgKBqIAAjTIAVAAIAADTg");
	this.shape_13.setTransform(419.075,-32.325);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("AgLBqIAAi9IhDAAIAAgWICdAAIAAAWIhDAAIAAC9g");
	this.shape_14.setTransform(399.85,-32.325);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("Ag8BUQgXgZAAgsIAAh6IAXAAIAAB5QAAAiAQATQARATAbAAQAdAAAQgSQAQgSAAgjIAAh6IAXAAIAAB5QAAAtgXAZQgWAYgngBQglABgXgYg");
	this.shape_15.setTransform(373.875,-32.15);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#000000").s().p("AhDBqIAAjTIAXAAIAAC9IBwAAIAAAWg");
	this.shape_16.setTransform(349.65,-32.325);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#000000").s().p("AgnAMIAAgXIBPAAIAAAXg");
	this.shape_17.setTransform(328.4,-30.825);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#000000").s().p("AhKBNQgcgfAAgtIAAgBQAAgsAdgfQAegiArABQAtAAAdAgQAdAgAAAsIAAAAQAAAtgdAgQgeAggsAAQgsABgeghgAg4g9QgWAZAAAkIAAAAQAAAlAWAZQAXAZAhABQAiAAAXgaQAWgZAAgkIAAgBQAAgjgWgaQgXgZgiAAQghAAgXAZg");
	this.shape_18.setTransform(304.575,-32.35);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#000000").s().p("AgJBqIhWjUIAZAAIBHC2IBHi2IAYAAIhWDUg");
	this.shape_19.setTransform(277,-32.25);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#000000").s().p("AhJBqIAAjTICRAAIAAAWIh5AAIAABIIBsAAIAAAVIhsAAIAABKIB6AAIAAAWg");
	this.shape_20.setTransform(251.4,-32.325);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#000000").s().p("AgKBqIAAi9IhEAAIAAgWICdAAIAAAWIhEAAIAAC9g");
	this.shape_21.setTransform(211.8,-32.325);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#000000").s().p("ABABqIhAhcIhABcIgaAAIBNhrIhKhoIAbAAIA8BXIA+hXIAaAAIhKBoIBNBrg");
	this.shape_22.setTransform(186.325,-32.325);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#000000").s().p("AhIBqIAAjTICQAAIAAAWIh6AAIAABIIBtAAIAAAVIhtAAIAABKIB8AAIAAAWg");
	this.shape_23.setTransform(161.1,-32.325);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#000000").s().p("ABDBqIiBitIAACtIgWAAIAAjTIAVAAIB+CpIAAipIAWAAIAADTg");
	this.shape_24.setTransform(133.8,-32.325);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#000000").s().p("AA3BqIg5hSIg6AAIAABSIgWAAIAAjTIBVAAQAmAAATAVQAQARAAAZIAAABQAAAZgQAQQgOAPgZAEIA+BXgAg8ACIA9AAQAXAAAOgKQAPgMAAgVIAAAAQAAgUgOgLQgNgLgYAAIg+AAg");
	this.shape_25.setTransform(92.725,-32.325);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#000000").s().p("Ag7BUQgYgZAAgsIAAh6IAXAAIAAB5QAAAiARATQAQATAcAAQAcAAAQgSQAQgSAAgjIAAh6IAXAAIAAB5QAAAtgXAZQgWAYgngBQglABgWgYg");
	this.shape_26.setTransform(64.875,-32.15);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#000000").s().p("AhJBNQgdgfAAgtIAAgBQAAgsAdgfQAegiArABQAtAAAeAgQAcAgAAAsIAAAAQAAAtgdAgQgeAggsAAQgsABgdghgAg4g9QgWAZAAAkIAAAAQAAAlAXAZQAWAZAhABQAiAAAXgaQAWgZAAgkIAAgBQAAgjgWgaQgXgZgiAAQghAAgXAZg");
	this.shape_27.setTransform(36.025,-32.35);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#000000").s().p("AgLBqIAAhUIhTh/IAcAAIBCBpIBEhpIAbAAIhTB/IAABUg");
	this.shape_28.setTransform(9.5,-32.325);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#000000").s().p("AgXEDQgNgVAFggQANhNBAiNQhpBZgkgHQgVgDADgUQADgWAQgjQAOgfAJgMQACgDAAgDIgBgBQgdAJgYgEQgSgDgOgMQgVApgXAiQgeAugMgCQgLgBgGgQQgFgOACgPQADgUAPgmQAKgbgFgBQgIgBhEBfQhFBggMgCQgWgEAFgmQAEgcAthcQAthaADgIQADgIgCgHQgCgHAPAJQAOAJgCAMQAAAFgyBcQgyBbgEAeQgBAIAGAAQAJgBBChbQBAhbAKACQANACAGAPQAEANgCAPIgOAvQgLAgAHABQAJACAcgoQAYglANgdQgHgLACgFQABgIAHABQAPAEgBAJIgFAMQAJAKAPACQAWAEARgDQAMgCANgGQAFgHADgBIAEABQAFgCABAGQAHAGAEAHQAFAHgCACQgaAdgYAnQgaAsAJAGQALAHA0giQAtgdArglQAWgtAgg9QgzgEg0AAIgQATQgDAEgFgEQgGgFACgDIAFgMQhHAAgoAFQgFAAgDgKQgCgLAIAAQAhgBBVAEIAHgPQACgFAJAIQALAJgCAFIBjAHQAqhOAYgjQAEgFAVAIQAZAJgDAHQgBABgFAAQgGABgEACQgbANguBPQA5AFAWAEIADAAQA5hiAjggQALgLAIACQAKACAKAHQAKAIgCADQgBADgHgBQgKgBgGADQghARg9BnQATAGAIAJQAFAFgBAFQgBALgKgBQgBgBAAAAQgBAAAAgBQAAAAgBgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQABgBAAAAQABgBAAAAQAGgCgEgFQgGgHgTgFQgoBFgiBIQghBIgEAZQAtg3AogjQAqglARADQANACAGALQAGAKgCAMQgCAKgMAYQgMAWgBALQgCALAJACQAbAEBtheQADgCACAEQACAEgEADQhwBggYgEQgPgCgIgLQgIgKACgLQABgHAKgcQALgdABgFQACgKgFgBQgRgCgzA0Qg1A2ghA4QgCADgKgFQgJgGAAgFQAGgmAlhTQAjhOAthPIgJgCQgPgDg6gEQgtBPgpBkQgqBngLBCQgFAcAJAUQAFANgDAAIgBAAQgLAAgKgPg");
	this.shape_29.setTransform(321.2668,15.8901);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},139).to({state:[]},1).wait(160));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-43.3,479.1,86.6);


// stage content:
(lib.EVO4Campaign2024_TheAudioTailor_1920x853px_Html5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// OfferValidUntil
	this.instance = new lib.OfferValidUntil("synched",0);
	this.instance.setTransform(1620.65,808.35,1.0667,1.0667,0,0,0,242.2,0);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(50).to({_off:false},0).to({alpha:1,startPosition:19},19,cjs.Ease.quartOut).wait(96));

	// Cursor
	this.instance_1 = new lib.Cursor("synched",0);
	this.instance_1.setTransform(207.5,919.75,1.0667,1.0667,0,0,0,13.2,0.1);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(86).to({_off:false},0).to({x:180.3,y:817.35,alpha:1,startPosition:19},19,cjs.Ease.quartOut).wait(60));

	// ShopNow
	this.instance_2 = new lib.ShopNow("synched",0);
	this.instance_2.setTransform(140.85,787.35,0.5653,0.5653,0,0,0,82.6,0);
	this.instance_2.alpha = 0;
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(63).to({_off:false},0).to({regX:82.5,scaleX:1.0667,scaleY:1.0667,x:140.9,alpha:1,startPosition:19},19,cjs.Ease.backOut).wait(83));

	// Mission700Speakers
	this.instance_3 = new lib.Mission700Speakers("synched",0);
	this.instance_3.setTransform(325.85,573.85,0.448,0.448,0,0,0,276.6,0);
	this.instance_3.alpha = 0;
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(50).to({_off:false},0).to({regX:276.5,scaleX:1.0667,scaleY:1.0667,alpha:1,startPosition:19},19,cjs.Ease.backOut).wait(96));

	// ThirtyOff
	this.instance_4 = new lib.ThirtyOff("synched",0);
	this.instance_4.setTransform(276.55,328.65,0.576,0.576,0,0,0,208.8,0.1);
	this.instance_4.alpha = 0;
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(37).to({_off:false},0).to({regX:208.7,scaleX:1.0667,scaleY:1.0667,y:328.7,alpha:1,startPosition:19},19,cjs.Ease.backOut).wait(109));

	// _YourNext
	this.instance_5 = new lib.YourNext("synched",0);
	this.instance_5.setTransform(315.9,204.9,0.6186,0.6186,0,0,0,239.7,0);
	this.instance_5.alpha = 0;
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(25).to({_off:false},0).to({regX:239.6,scaleX:1.0667,scaleY:1.0667,alpha:1,startPosition:19},19,cjs.Ease.backOut).wait(121));

	// WharfedaleLogo
	this.instance_6 = new lib.WharfedaleLogo("synched",0);
	this.instance_6.setTransform(252.9,76.75,0.6293,0.6293,0,0,0,182.6,0.1);
	this.instance_6.alpha = 0;
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(13).to({_off:false},0).to({scaleX:1.0667,scaleY:1.0667,x:252.95,y:76.85,alpha:1,startPosition:19},19,cjs.Ease.backOut).wait(133));

	// WhiteBG
	this.instance_7 = new lib.WhiteBG("synched",0);
	this.instance_7.setTransform(-272.05,284.85,1.0667,1.0667,0,0,0,943.5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(165));

	// BGImage
	this.instance_8 = new lib.BGImage("synched",0);
	this.instance_8.setTransform(-261.95,383.2,1.0667,1.0667,0,0,0,713.5,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({regX:713.6,regY:0,x:1271,y:402.65,startPosition:26},19,cjs.Ease.quartOut).wait(146));

	// White
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EiV/BCrMAAAiFVMEr/AAAMAAACFVg");
	this.shape.setTransform(960,426.675);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(165));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-318.5,-341.6,2350.5,1679.6);
// library properties:
lib.properties = {
	id: '82F30E1F771EE9438EB01873973B3956',
	width: 1920,
	height: 853,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"https://cdn.shopify.com/s/files/1/2109/2929/files/EVO4Campaign2024_AVR_1800x800px_BG.jpg?v=1727345628", id:"EVO4Campaign2024_AVR_1800x800px_BG"},
		{src:"https://cdn.shopify.com/s/files/1/2109/2929/files/EVO4Campaign2024_Speakers.png?v=1727345628", id:"EVO4Campaign2024_Speakers"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['82F30E1F771EE9438EB01873973B3956'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;